import * as XLSX from "xlsx";
import axios from "axios";

export async function downloadReference(data) {
  axios.defaults.headers["Authorization"] = localStorage.getItem("token");

  let designationMap = {};
  try {
    const response = await axios.get(
      process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all"
    );
    // Create a map of designation id to title
    designationMap = response.data.reduce((map, designation) => {
      map[designation.id] = designation.title;
      return map;
    }, {});
  } catch (error) {
    // console.error("Error fetching designations:", error);
  }

  // Define the headers
  const headers = [
    "S#",
    "Trainee Name",
    "Designation",
    "Phone",
    "Referees Name",
    "Email",
    "Relationship",
    "Organization",
    "Designation",
    "Contact#",
  ];

  // Prepare the data for the sheet
  const sheetData = [headers];

  let serialNumber = 1;
  data.forEach((person) => {
    let firstRow = true;
    person.References.forEach((reference) => {
      const row = [
        firstRow ? serialNumber : "", // Merge S#
        firstRow ? person.name : "", // Merge Trainee
        firstRow
          ? designationMap[person.designation] || person.designation
          : "", // Merge Designation with title
        firstRow ? person.contactNo : "", // Merge Phone
        reference.name, // Referee Name
        reference.email,
        reference.relation, // Relationship
        reference.organization,
        reference.designation,
        reference.contactNo,
      ];
      sheetData.push(row);
      firstRow = false; // Merge only the first row
    });
    serialNumber++;
  });

  // Create worksheet and workbook
  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  // Merge cells for S#, Trainee, Designation, and Phone
  let mergeRanges = [];
  let rowIndex = 1;
  data.forEach((person) => {
    if (person.References.length > 1) {
      mergeRanges.push(
        {
          s: { r: rowIndex, c: 0 },
          e: { r: rowIndex + person.References.length - 1, c: 0 },
        }, // S#
        {
          s: { r: rowIndex, c: 1 },
          e: { r: rowIndex + person.References.length - 1, c: 1 },
        }, // Trainee
        {
          s: { r: rowIndex, c: 2 },
          e: { r: rowIndex + person.References.length - 1, c: 2 },
        }, // Designation
        {
          s: { r: rowIndex, c: 3 },
          e: { r: rowIndex + person.References.length - 1, c: 3 },
        } // Phone
      );
    }
    rowIndex += person.References.length;
  });
  ws["!merges"] = mergeRanges;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "References");

  // Save the file
  XLSX.writeFile(wb, "References.xlsx");
}
